import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/request-number";

const API_PATH_PUBLIC = ConstantList.API_ENPOINT + "/public";

export const listRequestNumberRoom = (obj) =>
  axios.post(API_PATH + "/list-request-number-room", obj);

export const saveRequestNumber = (searchObject) =>
  axios.post(API_PATH + "/save", searchObject);
export const getMaxNumberOfDay = () =>
  axios.get(API_PATH + "/get-max-number-of-day");
export const pagingRequestNumber = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);
export const pagingRequestNumberRoom = (searchObject) =>
  axios.post(API_PATH + "/search-by-page-by-room", searchObject);

export const getRequestNumberById = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);
export const getAllRequestNumber = () => axios.get(API_PATH + "/get-all");
export const receivePatient = (obj) =>
  axios.post(API_PATH + "/receive-patient", obj);
export const skipPatient = (obj) => axios.post(API_PATH + "/skip-patient", obj);
export const cancelReceive = (obj) =>
  axios.post(API_PATH + "/cancel-receive", obj);
export const getNextRequestNumberCurrentDate = () =>
  axios.get(API_PATH + "/get-next-request-number");
export const getJustReqNumberToday = () =>
  axios.get(API_PATH + "/get-just-served-request-number");
export const getNextRequestNumberByRoomAndType = (roomCode, type) =>
  axios.get(
    API_PATH + "/get-next-request-number-room-type/" + roomCode + "/" + type
  );
export const saveRequestNumberList = (obj) =>
  axios.post(API_PATH + "/list-request-number-by-list-room-code", obj);

export const saveRequestNumberPublic = (searchObject) =>
  axios.post(API_PATH_PUBLIC + "/save", searchObject);
export const getMaxNumberOfDayPublic = () =>
  axios.get(API_PATH_PUBLIC + "/get-max-number-of-day");
export const pagingRequestNumberPublic = (searchObject) =>
  axios.post(API_PATH_PUBLIC + "/search-by-page", searchObject);
export const getRequestNumberByIdPublic = (id) =>
  axios.get(API_PATH_PUBLIC + "/get-by-id/" + id);
export const getAllRequestNumberPublic = () =>
  axios.get(API_PATH_PUBLIC + "/get-all");
export const receivePatientPublic = (obj) =>
  axios.post(API_PATH_PUBLIC + "/receive-patient", obj);
export const skipPatientPublic = (obj) =>
  axios.post(API_PATH_PUBLIC + "/skip-patient", obj);
export const cancelReceivePublic = (obj) =>
  axios.post(API_PATH_PUBLIC + "/cancel-receive", obj);
export const getNextRequestNumberCurrentDatePublic = () =>
  axios.get(API_PATH_PUBLIC + "/get-next-request-number");
export const getJustReqNumberTodayPublic = () =>
  axios.get(API_PATH_PUBLIC + "/get-just-served-request-number");
export const getNextRequestNumberByRoomAndTypePublic = (roomCode, type) =>
  axios.get(
    API_PATH_PUBLIC +
      "/get-next-request-number-room-type/" +
      roomCode +
      "/" +
      type
  );
export const saveRequestNumberListPublic = (obj) =>
  axios.post(API_PATH_PUBLIC + "/list-request-number-by-list-room-code", obj);

export const saveBookingRequest = (obj) =>
  axios.post(API_PATH_PUBLIC + "/save-request-number", obj);
export const getByIdRequestPublic = (id) =>
  axios.get(API_PATH_PUBLIC + "/get-by-id-request-number/" + id);
export const getByCodeRequestPublic = (code) =>
  axios.get(API_PATH_PUBLIC + "/get-by-look-up-code-request-number/" + code);

export const confirmBookingExam = (obj) =>
  axios.post(API_PATH + "/save-request-number-with-rooms", obj);
export const estimateExamTimeForListRoom = (arr) =>
  axios.post(API_PATH + "/estimate-time-for-room", arr);
export const cancelBookingExam = (obj) =>
  axios.post(API_PATH + "/cancel-confirm", obj);
export const cancelAppointment = (obj) =>
  axios.post(API_PATH + "/cancel-appointment", obj);

export const callPatientNumber = (obj) =>
  axios.post(API_PATH + "/call-patient-number", obj);
export const skipPatientNumber = (obj) =>
  axios.post(API_PATH + "/skip-patient-number", obj);
export const cancelPatientNumber = (obj) =>
  axios.post(API_PATH + "/cancel-patient-number", obj);
export const finalizeApointment = (obj) =>
  axios.post(API_PATH + "/update-number-of-reception-room", obj);
export const pagingWaitingImgStudyPatientByRoom = (searchObject) => axios.post(API_PATH + "/search-by-page-by-room", searchObject);